import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import FAQs from "../models/FAQs";

class FAQsService extends GenericCrudServiceV2<FAQs> {
  path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  findFAQsFilter(page: number, pageSize: number, title: string): Promise<ApiResponseV2<PagedResult<FAQs>>> {
    let url = `${this.basePath}/all?page=${page}&pageSize=${pageSize}&title=${title}`;
    return HttpClientV2.get(url);
  }
}

export default new FAQsService("/ensolvers-ops/faqs");
